import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';

export const GET_ALERT_TYPES_REQUEST = 'GET_ALERT_TYPES_REQUEST';
export const GET_ALERT_TYPES_SUCCESS = 'GET_ALERT_TYPES_SUCCESS';
export const GET_ALERT_TYPES_ERROR = 'GET_ALERT_TYPES_ERROR';

export const UPDATE_ALERT_TYPE_REQUEST = 'UPDATE_ALERT_TYPE_REQUEST';
export const UPDATE_ALERT_TYPE_SUCCESS = 'UPDATE_ALERT_TYPE_SUCCESS';
export const UPDATE_ALERT_TYPE_ERROR = 'UPDATE_ALERT_TYPE_ERROR';

export const CLEAN_ALERT_TYPES = 'CLEAN_ALERT_TYPES';

// Get alertTypes
export function getAlertTypes() {
    return async (dispatch) => {
        try {
            dispatch(getAlertTypesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.get('/api/alert-types', { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getAlertTypesSuccess, getAlertTypesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getAlertTypesError));
        }
    };
}
function getAlertTypesRequest() {
    return {
        type: GET_ALERT_TYPES_REQUEST,
        isFetching: true
    };
}
function getAlertTypesSuccess (payload) {
    return {
        type: GET_ALERT_TYPES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getAlertTypesError(errorMessage) {
    return {
        type: GET_ALERT_TYPES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Update alertType
export function updateAlertType(alertTypeId, alertType) {
    return async (dispatch) => {
        try {
            dispatch(updateAlertTypeRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/alert-types/${alertTypeId}`, alertType, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateAlertTypeSuccess, updateAlertTypeError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateAlertTypeError));
        }
    };
}
function updateAlertTypeRequest() {
    return {
        type: UPDATE_ALERT_TYPE_REQUEST,
        isFetching: true
    };
}
function updateAlertTypeSuccess (payload) {
    return dispatch => {
        // Create notification for update alertType success
        dispatch(addNotification({
            message: 'Alerta actualizada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_ALERT_TYPE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateAlertTypeError(errorMessage) {
    return dispatch => {
        // Create notification for update serie error
        dispatch(addNotification({
            message: 'Error al actualizar la alerta',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_ALERT_TYPE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean alertTypes reducer
export function cleanAlertTypes() {
    return {
        type: 'CLEAN_ALERT_TYPES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/alert-types.js